import script from "./LoadingLOTR.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingLOTR.vue?vue&type=script&setup=true&lang=ts"

import "./LoadingLOTR.vue?vue&type=style&index=0&id=3944763a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3944763a"]])

export default __exports__